module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Open",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getOpenOffers($event)
      }
    },
    model: {
      value: (_vm.filters.openOfferFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "openOfferFilter", $$v)
      },
      expression: "filters.openOfferFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getOpenOffers
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportOfferOpen', 'Active Offer.xls')
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddProduct
    }
  }, [_vm._v("Add Offer")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.openOffers,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "offerNo",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Offer",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + "\n\t\t\t\t\t\t\t"), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bouns",
      "label": "Bonus"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Total"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leftNum",
      "label": "Left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Date Created"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expireDate",
      "label": "Expiration Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEditOffer(scope.row.offerNo)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.archiveOffer(scope.row.offerNo)
            }
          }
        }, [_vm._v("Archived")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.openOfferTotal
    },
    on: {
      "current-change": _vm.handleChangeOpenOffer
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Proposed",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getProposedOffers($event)
      }
    },
    model: {
      value: (_vm.filters.proposedFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "proposedFilter", $$v)
      },
      expression: "filters.proposedFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getProposedOffers
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Status : "
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "change": _vm.getProposedOffers
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportOfferProposed', 'Proposed Offer.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.proposedOffers,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 3) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("cancelled")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Date Created"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expireDate",
      "label": "Offer Expiration Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.status === 0) ? [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.confirmProposed(scope.row.id, 1)
            }
          }
        }, [_vm._v("Confirm")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.confirmProposed(scope.row.id, 2)
            }
          }
        }, [_vm._v("Reject")])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.proposedTotal
    },
    on: {
      "current-change": _vm.getProposedOffers
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Offer History",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getOfferHistory($event)
      }
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getOfferHistory
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Status : "
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "change": _vm.getOfferHistory
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Offering",
      "value": "offering"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Archived",
      "value": "archived"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Expired",
      "value": "expired"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportOfferHistory', 'Offer History.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdListLoading),
      expression: "thirdListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.offerHistory,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "offerNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Total"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leftNum",
      "label": "Left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Date Created"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status != 'offering') ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.reListOffer(scope.row.offerNo)
            }
          }
        }, [_vm._v("Relist")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getOfferDetail(scope.row.offerNo)
            }
          }
        }, [_vm._v("Detail")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.historyTotal
    },
    on: {
      "current-change": _vm.handleChangeOfferHistory
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Offer",
      "width": "80%",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addOffer",
    attrs: {
      "model": _vm.addOffer,
      "label-width": "220px",
      "rules": _vm.addOfferFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product",
      "prop": "productNo"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "800px"
    },
    attrs: {
      "filterable": "",
      "auto-complete": "off",
      "clearable": ""
    },
    model: {
      value: (_vm.addOffer.productNo),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "productNo", $$v)
      },
      expression: "addOffer.productNo"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": product.productNo,
        "label": product.productName
      }
    }, [_vm._v(_vm._s(product.condition + ' - ' + product.productName + ' (' + product.createDate + ')'))])
  }), 1), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "20px",
      "text-decoration": "underline",
      "color": "blue",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.addProductVisible = true
      }
    }
  }, [_vm._v("Add Product")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.addOffer.price),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "price", $$v)
      },
      expression: "addOffer.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total",
      "prop": "total"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.addOffer.total),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "total", $$v)
      },
      expression: "addOffer.total"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Expires At",
      "prop": "expireDate"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.addOffer.expireDate),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "expireDate", $$v)
      },
      expression: "addOffer.expireDate"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("By default, expires in 3 days")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.addOffer.note),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "note", $$v)
      },
      expression: "addOffer.note"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bonus",
      "prop": "bouns"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.addOffer.bouns),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "bouns", $$v)
      },
      expression: "addOffer.bouns"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "scope"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addOffer.scope),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "scope", $$v)
      },
      expression: "addOffer.scope"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "public"
    }
  }, [_vm._v("public")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "private"
    }
  }, [_vm._v("private")])], 1)], 1), _vm._v(" "), (_vm.addOffer.scope === 'private') ? _c('el-form-item', {
    attrs: {
      "label": "Users"
    }
  }, [_c('el-tree', {
    ref: "tree",
    attrs: {
      "data": _vm.groups,
      "show-checkbox": "",
      "default-expand-all": "",
      "node-key": "userNo",
      "highlight-current": "",
      "props": _vm.defaultProps
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    model: {
      value: (_vm.addOffer.notify),
      callback: function($$v) {
        _vm.$set(_vm.addOffer, "notify", $$v)
      },
      expression: "addOffer.notify"
    }
  }, [_vm._v("Notify every who can see the offer")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddOffer($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Offer",
      "width": "80%",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editOffer",
    attrs: {
      "model": _vm.editOffer,
      "label-width": "220px",
      "rules": _vm.editOfferFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product",
      "prop": "productNo"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editOffer.productNo),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "productNo", $$v)
      },
      expression: "editOffer.productNo"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": product.productNo,
        "label": product.productName
      }
    }, [_vm._v(_vm._s(product.condition + ' - ' + product.productName + ' (' + product.createDate + ')'))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editOffer.price),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "price", $$v)
      },
      expression: "editOffer.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Original Total",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editOffer.quantity),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "quantity", $$v)
      },
      expression: "editOffer.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Left",
      "prop": "leftNum"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": _vm.editOffer.quantity
    },
    model: {
      value: (_vm.editOffer.leftNum),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "leftNum", $$v)
      },
      expression: "editOffer.leftNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Expires At",
      "prop": "expireDate"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.editOffer.expireDate),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "expireDate", $$v)
      },
      expression: "editOffer.expireDate"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("By default, expires in 3 days")])]), _vm._v(" "), (_vm.editOffer.scope == 'private') ? _c('el-form-item', {
    attrs: {
      "label": "User"
    }
  }, _vm._l((_vm.editOffer.users), function(user, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "type": "info"
      }
    }, [_vm._v(_vm._s(user))])
  }), 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.editOffer.note),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "note", $$v)
      },
      expression: "editOffer.note"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bonus",
      "prop": "bouns"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editOffer.bouns),
      callback: function($$v) {
        _vm.$set(_vm.editOffer, "bouns", $$v)
      },
      expression: "editOffer.bouns"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleEditOffer($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "ReList Offer",
      "width": "80%",
      "visible": _vm.relistFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.relistFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "relistOffer",
    attrs: {
      "model": _vm.relistOffer,
      "label-width": "220px",
      "rules": _vm.editOfferFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product",
      "prop": "productNo"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.relistOffer.productNo),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "productNo", $$v)
      },
      expression: "relistOffer.productNo"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": product.productNo,
        "label": product.productName
      }
    }, [_vm._v(_vm._s(product.condition + ' - ' + product.productName + ' (' + product.createDate + ')'))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.relistOffer.price),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "price", $$v)
      },
      expression: "relistOffer.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Original Total",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.relistOffer.quantity),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "quantity", $$v)
      },
      expression: "relistOffer.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Left",
      "prop": "leftNum"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": _vm.relistOffer.quantity
    },
    model: {
      value: (_vm.relistOffer.leftNum),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "leftNum", $$v)
      },
      expression: "relistOffer.leftNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Expires At",
      "prop": "expireDate"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "disabled": true
    },
    model: {
      value: (_vm.relistOffer.expireDate),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "expireDate", $$v)
      },
      expression: "relistOffer.expireDate"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "New Expires At",
      "prop": "newExpireDate"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.relistOffer.newExpireDate),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "newExpireDate", $$v)
      },
      expression: "relistOffer.newExpireDate"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("By default, expires in 3 days")])]), _vm._v(" "), (_vm.relistOffer.scope == 'private') ? _c('el-form-item', {
    attrs: {
      "label": "User"
    }
  }, _vm._l((_vm.relistOffer.users), function(user, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "type": "info"
      }
    }, [_vm._v(_vm._s(user))])
  }), 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.relistOffer.note),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "note", $$v)
      },
      expression: "relistOffer.note"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bonus",
      "prop": "bouns"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.relistOffer.bouns),
      callback: function($$v) {
        _vm.$set(_vm.relistOffer, "bouns", $$v)
      },
      expression: "relistOffer.bouns"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.relistFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleReListOffer($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Product",
      "width": "80%",
      "visible": _vm.addProductVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addProductVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addProduct",
    attrs: {
      "model": _vm.addProduct,
      "label-width": "220px",
      "rules": _vm.addProductFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "product"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.product),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "product", $$v)
      },
      expression: "addProduct.product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.addProduct.price),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "price", $$v)
      },
      expression: "addProduct.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.condition),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "condition", $$v)
      },
      expression: "addProduct.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN",
      "prop": "asin"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.asin),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "asin", $$v)
      },
      expression: "addProduct.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC",
      "prop": "upc"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.upc),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "upc", $$v)
      },
      expression: "addProduct.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight",
      "prop": "weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.weight),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "weight", $$v)
      },
      expression: "addProduct.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.note),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "note", $$v)
      },
      expression: "addProduct.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addProductVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddProduct($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Offer Detail",
      "width": "80%",
      "visible": _vm.offerDetailVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.offerDetailVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getOfferDetail()
      }
    },
    model: {
      value: (_vm.filters.offerDetailFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "offerDetailFilter", $$v)
      },
      expression: "filters.offerDetailFilter"
    }
  }, _vm._l((_vm.nurseList), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.offerDetails,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "takeDate",
      "label": "Offer Take Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.offerDetailTotal
    },
    on: {
      "current-change": _vm.handleChangeOfferDetail
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.offerDetailVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50402687"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/doctor/offer.vue
// module id = 781
// module chunks = 1